import React, { useContext } from 'react';

import { ApiPortfolioState } from '../../dashboard/models/ApiPortfolioState';

interface LessonPlayerMarkingContextModel {
  state: ApiPortfolioState;
  assignedToMe: boolean;
  canFinalize: boolean;
  markerUserkey: number;
}

const LessonPlayerMarkingContext =
  React.createContext<LessonPlayerMarkingContextModel>({
    state: ApiPortfolioState.Unknown,
    assignedToMe: false,
    canFinalize: false,
    markerUserkey: null
  });

export const useLessonPlayerMarkingContext = () =>
  useContext(LessonPlayerMarkingContext);

export const LessonPlayerMarkingContextProvider =
  LessonPlayerMarkingContext.Provider;
export const LessonPlayerMarkingContextConsumer =
  LessonPlayerMarkingContext.Consumer;
export default LessonPlayerMarkingContext;
